<template>
  <v-app class="bg-aqua-teal d-flex align-center justify-center" style="height: 100vh;">
    <v-container style="margin-top: 25vh;">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-progress-linear :active="loading" :indeterminate="loading" color="#FF6D44"/>
          <v-card outlined class="pa-5">
            <v-card-title class="text-center text-h5 font-weight-bold">
              Reset Password
            </v-card-title>
            <v-card-text v-if="!transition">
              <v-form ref="resetForm" v-model="isFormValid">
                <v-text-field v-model="password" label="New Password" type="password" outlined dense
                  :rules="[rules.required, rules.minLength]"></v-text-field>

                <v-text-field v-model="confirmPassword" label="Confirm New Password" type="password" outlined dense
                  :rules="[rules.required, rules.matchPassword]"></v-text-field>
              </v-form>
              <div class="d-flex justify-center mt-4">
                <v-btn class="bg-bright-orange text-pure-white" :disabled="!isFormValid" @click="resetPassword">
                  Reset Password
                </v-btn>
              </div>
            </v-card-text>
            <v-card-text v-else-if="transition === 1" class="text-center">
              Password Reset
              <div class="d-flex justify-center">
                <v-btn class="bg-bright-orange text-pure-white" @click="returnToLogin">
                  Login
                </v-btn>
              </div>
            </v-card-text>
            <v-card-text v-else>
              Password reset token expired. Please request a new one.
              <div class="d-flex justify-center">
                <v-btn class="bg-bright-orange text-pure-white" @click="forgotPassword">
                  Reset
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
export default {
  name: "ResetPassword",
  data() {
    return {
      password: "",
      confirmPassword: "",
      isFormValid: false,
      rules: {
        required: (value) => !!value || "This field is required",
        minLength: (value) => value.length >= 6 || "Password must be at least 6 characters",
        matchPassword: (value) => value === this.password || "Passwords must match",
      },
      transition: 0,
      loading: false,
    };
  },
  methods: {
    async resetPassword() {
      this.loading = true;
      if (this.$refs.resetForm.validate()) {
        try {
          var request = {
            "email": this.$route.query.email,
            "token": this.$route.query.token,
            "newPassword": this.password
          };
          await axios.post("api/auth/reset-password", request);
          this.loading = false;
          this.transition = 1;
          return;
        } catch (error) {
          "";
        }
        this.loading = false;
        this.transition = 2;
      }
    },
    returnToLogin() {
      this.$router.push({ name: "LoginPage" });
    },
    forgotPassword() {
      this.$router.push({ name: 'ForgotPasswordPage' });
    }
  },
};
</script>

<style>
.text-aqua-teal {
  color: #08B6AA;
}

.text-pure-black {
  color: #000000;
}

.text-pure-white {
  color: #FFFFFF;
}

.bg-aqua-teal {
  background-color: #08B6AA !important;
}

.bg-bright-orange {
  background-color: #FF6D44 !important;
}
</style>